import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { FIND_APPS_BUTTON_SIZE } from "../../constants";
import { StyledFiltersPanelExpandButton } from "../styles";

import { StyledFiltersPanelCollapsedBar, StyledTitle, StyledTitleWrap } from "./styles";

type CollapsedBarProps = {
    className?: string;
    title: ReactElement;
    onExpandClick(): void;
};

const FiltersPanelCollapseBar = (props: CollapsedBarProps) => {
    const { className, title, onExpandClick } = props;

    return (
        <StyledFiltersPanelCollapsedBar
            className={className}
            data-automation="filters-panel.collapsed-bar"
            onClick={onExpandClick}
        >
            <Flex justifyContent="center">
                <StyledFiltersPanelExpandButton
                    height={FIND_APPS_BUTTON_SIZE}
                    width={FIND_APPS_BUTTON_SIZE}
                    iconName="chev-right"
                    tooltipText={translate("si.lead_gen_filters.button.expand.tooltip")}
                    isDisabled={typeof onExpandClick !== "function"}
                />
            </Flex>
            <StyledTitleWrap>
                <StyledTitle>{title}</StyledTitle>
            </StyledTitleWrap>
        </StyledFiltersPanelCollapsedBar>
    );
};

export default FiltersPanelCollapseBar;
